import { useAtom } from "jotai";
import {
  isMobileAtom,
  isFullWidthAtom,
  appLoadedAtom,
  selectedFontAtom,
} from "../../store/atoms/uiAtoms.js";

// UI State Hook
export const useUI = () => {
  const [isMobile, setIsMobile] = useAtom(isMobileAtom);
  const [isFullWidth, setIsFullWidth] = useAtom(isFullWidthAtom);
  const [appLoaded, setAppLoaded] = useAtom(appLoadedAtom);
  const [selectedFont, setSelectedFont] = useAtom(selectedFontAtom);

  return {
    isMobile,
    setIsMobile,
    isFullWidth,
    setIsFullWidth,
    appLoaded,
    setAppLoaded,
    selectedFont,
    setSelectedFont,
  };
};
